// checkoutData holds the data for the new checkout page
// ALL checkout data must be stored here. If data is stored elsewhere (e.g. user data), it must be synced here
// This gives us a single access point for all checkout data
// Once the new checkout page is fully launched, we can remove the legacy reducer

import { CheckoutState, DateOfBirth, PreferredContactMethod } from 'pages/checkout/connect/types';

const dateOfBirthInitialState: DateOfBirth = {
  day: '',
  month: '',
  year: '',
};

export const checkoutDataInitialState: CheckoutState = {
  timeRemaining: null,

  account: {
    email: '',
    phone: '',
    phoneToSave: '',
    phoneToUpdate: '',
  },

  patient: {
    firstName: '',
    lastName: '',
    dateOfBirth: dateOfBirthInitialState,
    sexAssignedAtBirth: null,
  },

  survey: {
    urgent: null,
    urgentDetails: '',
    urgentDetailsOther: '',
    treatments: [],
    treatmentsOther: '',
    anxiety: '',
    lastVisited: '',
  },

  insurance: {
    hasInsurance: null,
    provider: {
      name: '',
      id: '',
    },
    plan: {
      name: '',
      id: '',
    },
    memberId: '',
    groupId: '',
    isPrimaryMember: null,
    primaryMember: {
      firstName: '',
      lastName: '',
      dateOfBirth: dateOfBirthInitialState,
    },
  },

  confirm: {
    preferredContactMethods: {
      [PreferredContactMethod.Phone]: false,
      [PreferredContactMethod.SMS]: false,
    },
    note: '',
  },
};
